import Cookies from 'js-cookie';

const EnquiryStore = () => {
    const keyRemember = "cmp.ret.enq.rememberDetails";
    const keyStore = "cmp.ret.enq.details";

    const _setRemember = (value) => {
        Cookies.set(keyRemember, value, { expires: 30 });
    };

    const _forget = () => {
        if (!localStorage) return false;
        localStorage.removeItem(keyStore);
        _setRemember('false');
        return true;
    };

    const _save = (obj) => {
        if (!localStorage || !obj) return false;
        localStorage.setItem(keyStore, encodeURIComponent(JSON.stringify(obj)));
        _setRemember('true');
        return true;
    };

    const _saveFromUserData = (userData) => {
        if (!localStorage || !userData) return false;

        for (let item of userData) {
            for (let key in item.data) {
                if (key === keyStore) {
                    return _save(JSON.parse(item.data[key]));
                }
            }
        }

        return false;
    };

    const _get = () => {
        if (!localStorage) return false;
        if (!_doRemember()) return false;

        const data = localStorage.getItem(keyStore);

        if (data) return JSON.parse(decodeURIComponent(data));

        return null;
    };

    const _doRemember = () => {
        if (!localStorage) return false;

        const doRemember = Cookies.get(keyRemember);

        // If user has no preference then default is remember user details
        if (doRemember === null || (typeof doRemember === 'undefined')) return true;

        return doRemember === 'true';
    };

    return {
        forget: _forget,
        save: _save,
        saveFromUserData: _saveFromUserData,
        get: _get,
        doRemember: _doRemember
    };
};

export default EnquiryStore;